<template>
  <view class="sunflower-code">
    <view class="tip">{{ config.titleTip }}</view>
    <view class="title">{{ config.content }}</view>
    <view class="code-content">
      <image wx:show="{{codeImageUrl}}" class="code-image" src="{{codeImageUrl}}" mode="widthFix"	show-menu-by-longpress="{{true}}" />
    </view>
    <view class="btn" bindtap="click" id="saveBtn">
      {{ config.btnText }}
      <image wx:if="{{ hasGetCoupon }}" class="light" src="https://ut-static.udache.com/webx/ut/6dMXZZlvPzAyILkloTHCe_saoguang_apng.apng" mode="widthFix" />
      <view wx:if="{{bonusRewardShow}}" class="bonus-reward">首次保存奖励{{initData.activity_info.save_poster_bonus}}福利金</view>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { trackEvent } from '@didi/webx-js'
import store from '../../lib/store'

createComponent({
  properties: {
    codeImageUrl: String,
    config: Object,
    hasGetCoupon: Boolean,
  },
  computed: {
    ...store.mapGetters([ 'initData' ]),
    bonusRewardShow() {
      return this.initData.activity_info && !this.initData.activity_info.has_saved_poster && this.initData.activity_info.save_poster_bonus > 0
    },
  },
  ready() {
    if (__mpx_mode__ === 'web') {
      if (!window.IntersectionObserver) {
        trackEvent('userteam_ddlm_coupon_playbill_save_sw', '【点击保存】按钮曝光', { bt_txt: this.config.btnText })
        return
      }
      const observer = new IntersectionObserver(mutations => {
        if (mutations[0].intersectionRatio) {
          trackEvent('userteam_ddlm_coupon_playbill_save_sw', '【点击保存】按钮曝光', { bt_txt: this.config.btnText })
          observer.disconnect()
        }
      })
      observer.observe(document.querySelector('#saveBtn'))
    } else {
      const target = __mpx_mode__ === 'wx' ? this : my
      const observer = target.createIntersectionObserver()
      observer.observe('#saveBtn', res => {
        if (res.intersectionRatio) {
          trackEvent('userteam_ddlm_coupon_playbill_save_sw', '【点击保存】按钮曝光', { bt_txt: this.config.btnText })
          observer.disconnect()
        }
      })
    }
  },
  methods: {
    click(e) {
      trackEvent('userteam_ddlm_coupon_playbill_save_ck', '海报区', { bt_txt: this.config.btnText })
      this.triggerEvent('savePosterImg', e.detail)
    },
  },
})
</script>

<style lang="stylus" scoped>
@keyframes btn-breath {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.06);
  }
  100% {
    transform: scale(1);
  }
}
  .sunflower-code
    box-sizing: border-box
    width 750rpx
    height 590rpx
    background: url('https://ut-static.udache.com/webx/ut/i0iM3mAFyf9dMZTa3yP0I.png')
    background-repeat: no-repeat
    background-size: 100vw auto
    background-color: RGB(255, 102, 0)
    display: flex;
    align-items: center
    flex-direction: column
    .tip
      font-size: 22rpx;
      color: #CA7027;
      letter-spacing: 2rpx;
      text-align: center;
      font-weight: 700;
      margin-top: 18rpx
      font-family: AlibabaPuHuiTi-Bold;
    .title
      font-family: PingFangSC-Semibold;
      font-size: 32rpx;
      color: #F15711;
      letter-spacing: 2rpx;
      text-align: center;
      line-height: 50rpx;
      margin 32rpx 0 28rpx 0
      font-weight: 600;
    .code-content
      width: 240rpx
      height: 240rpx
      .code-image
        width: 240rpx
        height: 240rpx
    .btn
      font-family: AlibabaPuHuiTi-Medium;
      width: 530rpx;
      height: 90rpx;
      line-height: 90rpx;
      margin-top: 9rpx;
      background: #FF5000;
      background-image: linear-gradient(219deg, #FF6B00 0%, #FF5000 77%);
      border-radius: 66.5rpx;
      font-size: 42rpx;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
      position relative
      .light
        position absolute
        left 0
        top 0
        width 530rpx
      .bonus-reward
        position absolute
        right -82rpx
        top -50rpx
        width 274rpx
        height 54rpx
        line-height 46rpx
        background-image url(https://ut-static.udache.com/webx/ut/f1xNB9ZxVjqt9lNHVaUIW.png)
        background-size cover
        text-align center
        font-family: PingFangSC-Medium;
        font-size: 24rpx;
        color: #FFF;
        font-weight: 500;
        animation btn-breath 1s infinite
</style>

<script type="application/json" lang="json">
{
  "component": true,
  "usingComponents": {}
}
</script>

